import React from 'react'
import { TaskSummaryHeaderContainer } from '../styles'
import { noop } from 'lodash'
import ErrorDotTitle from 'components/Shared/ErrorDotTitle'
import Text from 'particles/Text'
import { theme } from 'theme'
import Icon from 'components/Icon'
import { parseBackendDate } from 'services/dates'
import { useNewTranslation } from 'hooks'
import { useSelector } from 'react-redux'
import { selectEditingCampaign } from 'state/campaigns'
import { ScheduleType } from 'state/registrations'
import IconButton from 'particles/Button/IconButton'

interface TaskSummaryHeaderProps {
    title: string
    onClose?: (e?: React.MouseEvent<HTMLDivElement>) => void
    onActive: (e?: React.MouseEvent<HTMLDivElement>) => void
    isActive: boolean
    className?: string
    showClose?: boolean
    isShowErrorDot?: boolean
    schedule: ScheduleType
    isDraggable?: boolean
    icon: React.ReactNode
    isDragDisabled?: boolean
    commentCount?: number
}

const TaskSummaryHeader: React.FC<TaskSummaryHeaderProps> = ({
    title,
    onActive,
    isActive,
    onClose = noop,
    className,
    showClose = true,
    isShowErrorDot = false,
    schedule,
    isDraggable = false,
    isDragDisabled = false,
    icon,
    commentCount,
}) => {
    const [t] = useNewTranslation()
    const editingCampaign = useSelector(selectEditingCampaign)

    const { start, end } = schedule || {}
    const startDate = start
        ? parseBackendDate(start, editingCampaign?.country, {
              showTime: false,
              showYear: false,
          })
        : t('placeholderText.taskStartDate')
    const endDate = end
        ? parseBackendDate(end, editingCampaign?.country, {
              showTime: false,
              showYear: false,
              addSeconds: -1,
          })
        : t('placeholderText.taskEndDate')

    return (
        <TaskSummaryHeaderContainer
            isActive={isActive}
            className={className}
            isDraggable={isDraggable}
            isDragDisabled={isDragDisabled}
            showClose={showClose}
        >
            <div
                className="title-area"
                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    e.stopPropagation()
                    onActive()
                }}
            >
                {isDraggable && (
                    <div className="drag-icon">
                        <Icon.DotsSixVerticalIcon
                            size={20}
                            color={isDragDisabled ? theme.newColors.neutral400 : theme.newColors.neutral700}
                        />
                    </div>
                )}
                <div className="task-title">
                    <div style={{ display: 'flex' }}>
                        {icon}
                        <Text scale="caption400" color={isActive ? 'primary' : 'placeholder'}>
                            {startDate} - {endDate}
                        </Text>
                    </div>
                    <Text scale="bodyS700" color={isActive ? 'primary' : 'placeholder'}>
                        <ErrorDotTitle title={title} isShowDot={isShowErrorDot} />
                    </Text>
                </div>
            </div>
            <div className="comment-close-area">
                {showClose && (
                    <IconButton
                        icon="x"
                        size="xs"
                        color="neutral"
                        form="icon"
                        onClick={e => {
                            e.stopPropagation()
                            onClose()
                        }}
                    />
                )}
                {commentCount && !isActive ? (
                    <Text scale="caption500" color="neutralAction" className="comment-count">
                        {commentCount}
                    </Text>
                ) : null}
            </div>
        </TaskSummaryHeaderContainer>
    )
}
export default TaskSummaryHeader
